import React, { useState, useEffect } from 'react';
import styles from '../App.module.css';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay, parseISO, addMinutes } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import CalendarioEntrevista from '../components/Graficos/CalendarioEntrevista';
import PrimeirosAgendamento from "../components/PrimeirosAgendamento";
import ChatGPT from "../components/ChatGPT";
import Pendencias from "../components/controle/Pendencias";
import { isAuthenticated } from '../../src/index';
import { FaAddressCard, FaMousePointer, FaChalkboardTeacher, FaPencilAlt, FaRegListAlt, FaCashRegister, FaCalendarAlt, FaPeopleArrows, FaHotel } from 'react-icons/fa';
import { IoAirplane } from "react-icons/io5";
import { TbReportAnalytics } from "react-icons/tb";
import Analise from './analise';



const slides = [
    { src: '/banner/banner1wp.webp', link: 'https://www.exemplo1.com' },
    // { src: '/banner/banner3.png', link: 'https://www.exemplo1.com' },
];

const categories = [
    { name: 'Produzir', color: '#B2FFD1', link: '/produzir', icon: <FaPencilAlt size={30} color="#333" /> },
    { name: 'Monitorar', color: '#FFB2B2', link: '/monitorar', icon: <FaCalendarAlt size={30} color="#333" /> },
    { name: 'Produção', color: '#B2D6FF', link: '/producao', icon: <FaRegListAlt size={30} color="#333" /> },
    { name: 'Finanças', color: '#FFF2B2', link: '/financeiro', icon: <FaCashRegister size={30} color="#333" /> },
    { name: 'Parceiros', color: '#FFA0F2', link: '/parceiros', icon: <FaPeopleArrows size={30} color="#333" /> },
    { name: 'DS-EDITOR', color: '#3a62f2', link: '/dsEditor', icon: <FaMousePointer size={25} color="#fff" /> },
    { name: 'ADM', color: '#B2D6FF', link: '/adm', icon: <FaAddressCard size={30} color="#333" /> },
    { name: 'Treinamento (Em construção)', color: '#fff', link: '/analise', icon: <FaChalkboardTeacher size={30} color="#333" /> },
    { name: 'Passagens (Em construção)', color: '#fff', link: '/flightSearch', icon: <IoAirplane size={30} color="#333" /> },
    { name: 'Hoteis (Em construção)', color: '#fff', link: '/hotelSearch', icon: <FaHotel size={30} color="#333" /> },
    { name: 'Analytics (Em construção)', color: '#fff', link: '/analytics', icon: <TbReportAnalytics size={30} color="#333" /> },

];

const locales = {
    'pt-BR': ptBR,
};

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 0 }),
    getDay,
    locales,
});

const consuladosNomes = {
    54: "Brasilia",
    55: "Rio de Janeiro",
    56: "Sao Paulo",
    57: "Recife",
    128: "Porto Alegre"
};

const Home = () => {
    const { userNome, userCpf, userPermission } = isAuthenticated();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [datasIndividuais, setDatasIndividuais] = useState([]);
    const [datasGrupos, setDatasGrupos] = useState([]);
    const [loadingAgendamento, setLoadingAgendamento] = useState(true);
    // Filtra as categorias, mostrando ADM só se userPermission === 99
    const filteredCategories = categories.filter(
        cat => cat.name !== 'ADM' || userPermission === 99
    );


    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);
    const meuContexto = {
        role: "system",
        content: `Aqui estão as informações do usuário antes da conversa. O nome dele usuario é: ${JSON.stringify(userNome)}`
    };



    // Busca últimas datas individuais e grupos no backend
    useEffect(() => {
        async function fetchDatas() {
            setLoadingAgendamento(true);
            try {
                // Fetch individuais
                const respInd = await fetch('https://gscrm.vercel.app/agendamento-datas?grupo=1');
                const dataInd = await respInd.json();

                // Monta mapa cidade -> última data
                const mapaIndividuais = {};
                for (const [i, reg] of dataInd.entries()) {
                    let consulados;
                    if (typeof reg.consulados_json === 'string') {
                        try {
                            consulados = JSON.parse(reg.consulados_json);
                        } catch (err) {
                            console.error(`[${i}] Erro ao fazer parse do JSON dos consulados_json`, reg.consulados_json, err);
                            consulados = {};
                        }
                    } else {
                        consulados = reg.consulados_json;
                    }
                    for (const cod in consuladosNomes) {
                        if (!mapaIndividuais[cod] && consulados[cod]) {
                            mapaIndividuais[cod] = consulados[cod];
                        }
                    }
                }
                // Exibe o mapa final no console

                setDatasIndividuais(
                    Object.entries(consuladosNomes).map(([cod, nome]) => ({
                        consulado: nome,
                        data: mapaIndividuais[cod] ? formatarDataExtenso(mapaIndividuais[cod]) : "-"
                    }))
                );

                // Fetch grupos
                const respGrp = await fetch('https://gscrm.vercel.app/agendamento-datas?grupo=2');
                const dataGrp = await respGrp.json();
                const mapaGrupos = {};
                for (const [i, reg] of dataGrp.entries()) {
                    let consulados;
                    if (typeof reg.consulados_json === 'string') {
                        try {
                            consulados = JSON.parse(reg.consulados_json);
                        } catch (err) {
                            console.error(`[grupo ${i}] Erro ao fazer parse do JSON dos consulados_json`, reg.consulados_json, err);
                            consulados = {};
                        }
                    } else {
                        consulados = reg.consulados_json;
                    }
                    for (const cod in consuladosNomes) {
                        if (!mapaGrupos[cod] && consulados[cod]) {
                            mapaGrupos[cod] = consulados[cod];
                        }
                    }
                }

                setDatasGrupos(
                    Object.entries(consuladosNomes).map(([cod, nome]) => ({
                        consulado: nome,
                        data: mapaGrupos[cod] ? formatarDataExtenso(mapaGrupos[cod]) : "-"
                    }))
                );
            } catch (e) {
                console.error("❌ [fetchDatas] Erro ao buscar agendamento:", e);
            }
            setLoadingAgendamento(false);
        }
        fetchDatas();
    }, []);

    // Função para exibir a data em formato "d Mês, yyyy"
    function formatarDataExtenso(data) {
        try {
            // Se já estiver formatado, retorna
            if (!/^\d{4}-\d{2}-\d{2}$/.test(data)) return data;
            const meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
            const [ano, mes, dia] = data.split("-");
            return `${parseInt(dia)} ${meses[parseInt(mes) - 1]}, ${ano}`;
        } catch {
            return data;
        }
    }

    return (
        <div className={styles.app}>
            {/* <div style={{ width: "100%", maxWidth: "600px", textAlign: "left" }}>
                <p style={{ fontSize: "1rem", fontWeight: "600", padding: "5px" }}>Bem-vindo {userNome},</p>
            </div> */}
            <Pendencias user={userCpf} userPermission={userPermission} userCpf={userCpf} />
            {/* Carrossel de Categorias */}
            <div style={{ width: "100%", maxWidth: "600px", textAlign: "left", marginTop: "20px" }}>
                <p style={{ fontSize: "1rem", fontWeight: "600", padding: "5px" }}>Serviços</p>
            </div>
            <div
                style={{
                    width: " 100%",
                    maxWidth: "600px",
                    // padding:"20px"
                }}
            >
                <div className={styles.categoriesContainer} >
                    {filteredCategories.map((category, index) => (
                        <a key={index} href={category.link} className={styles.categoryItem} style={{ backgroundColor: category.color, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: "15px", textDecoration: "none", color: "black", fontWeight: "600", textAlign: "center" }}>
                            {category.icon}
                            <p style={{ whiteSpace: "pre-line" }}>{category.name}</p>
                        </a>
                    ))}
                </div>
            </div>

            <div
                className={styles.cadastroItems06}
                style={{
                    borderRadius: "20px",
                    backgroundColor: "white",
                    margin: "40px",
                    maxWidth: "600px",
                }}
            >
                <PrimeirosAgendamento
                    datasIndividuais={datasIndividuais}
                    datasGrupos={datasGrupos}
                    loading={false}
                />
            </div>

            {/* Calendario entrevista */}

            <Analise />


            {/* Calendario entrevista */}
            <div style={{ width: "100%", maxWidth: "600px", textAlign: "left", marginTop: "20px" }}>
                <p style={{ fontSize: "1rem", fontWeight: "600", padding: "5px" }}>Calendário</p>
            </div>
            {/* INICIO CALENDARIO */}
            <CalendarioEntrevista />
            <div className={styles.sliderContainer}
                style={{
                    marginTop: "20px",
                }}
            >
                <a href={"https://chromewebstore.google.com/detail/ds-editor/hicdanpokmlhkkcpblhmjckieofeipid"}>
                    <img
                        src={'/banner/banner1wp.webp'}
                        className={styles.sliderImage}
                    />
                </a>
            </div>
            <div
                className={styles.cadastroItems06}
                style={{
                    // padding: "20px",
                    borderRadius: "20px",
                    backgroundColor: "white",
                    margin: "40px",
                    maxWidth: "600px",
                }}
            >
                <ChatGPT contextMessage={meuContexto} />
            </div>
















        </div>
    );
};

export default Home;
